import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Buffer } from "buffer";
import { useSelector } from "react-redux";
import Page404 from "app/not-found";

const API_URL = process.env.REACT_APP_API_URL;

const PageListeProjets = () => {
  const { user } = useSelector((state) => state.user);
  const [projets, setProjets] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Stocker les previews des avatars
  const [avatarPreviews, setAvatarPreviews] = useState({});

  useEffect(() => {
    const fetchProjets = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/projets`);
        setProjets(res.data);

        // Générer les avatars retina pour chaque auteur
        const previews = {};
        res.data.forEach((projet) => {
          if (projet.auteur?.img?.data) {
            const img = new Image();
            img.src = `data:${projet.auteur.img.contentType};base64,${Buffer.from(
              projet.auteur.img.data
            ).toString("base64")}`;

            img.onload = () => {
              const displaySize = 32; // taille CSS de l'avatar
              const scale = window.devicePixelRatio || 1;
              const canvasSize = displaySize * scale;

              const canvas = document.createElement("canvas");
              canvas.width = canvasSize;
              canvas.height = canvasSize;

              const ctx = canvas.getContext("2d");
              ctx.clearRect(0, 0, canvasSize, canvasSize);
              ctx.imageSmoothingEnabled = true;
              ctx.imageSmoothingQuality = "high";

              const ratio = Math.max(canvasSize / img.width, canvasSize / img.height);
              const newWidth = img.width * ratio;
              const newHeight = img.height * ratio;
              const dx = (canvasSize - newWidth) / 2;
              const dy = (canvasSize - newHeight) / 2;

              ctx.drawImage(img, dx, dy, newWidth, newHeight);

              previews[projet._id] = canvas.toDataURL("image/png");
              // Mettre à jour l'état pour afficher le preview
              setAvatarPreviews((prev) => ({ ...prev, [projet._id]: previews[projet._id] }));
            };
          }
        });
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchProjets();
  }, []);

  if (loading) {
    return <p className="text-center mt-10">Chargement des projets…</p>;
  }

  if (!user) return <Page404 />;

  return (
    <div className="max-w-6xl mx-auto p-4">
      <h1 className="text-3xl font-bold text-center mb-8">
        Liste des projets
      </h1>

      {projets.length === 0 ? (
        <p className="text-center">Aucun projet disponible.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projets.map((projet) => (
            <div
              key={projet._id}
              onClick={() => navigate(`/admin/projets/${projet._id}`)}
              className="group cursor-pointer bg-white rounded-3xl shadow-md p-6 flex flex-col justify-between
                         transition-all duration-300
                         hover:bg-blue-50 hover:shadow-xl"
            >
              <div>
                <h2 className="text-xl font-semibold mb-3 group-hover:text-blue-700 transition-colors">
                  {projet.nom}
                </h2>
                <p className="text-gray-700 text-sm line-clamp-4">
                  {projet.descriptionCourte}
                </p>
              </div>

              <div className="mt-6 flex items-center justify-center gap-2 text-sm text-gray-500 group-hover:text-blue-600 transition-colors">
                {avatarPreviews[projet._id] ? (
                  <img
                    src={avatarPreviews[projet._id]}
                    alt="Avatar auteur"
                    className="w-8 h-8 rounded-full object-cover"
                  />
                ) : projet.auteur?.img ? (
                  <div className="w-8 h-8 rounded-full bg-gray-200" />
                ) : null}
                <span>{projet.auteur?.name || "Auteur inconnu"}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PageListeProjets;
